import { GetServerSideProps } from "next";
import { UserConfig } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "@/../next-i18next.config";
import { keyframes } from '@emotion/react';
import CategoryLayout from "@/app/layout/pages/categoryLayout";
import EggsLayout from "@/app/layout/pages/eggsLayout";

const zoomAndShake = keyframes`
   0% {
    transform: scale(0) ;
    opacity: 0.5;
  }
  50% {
    transform: scale(1.1) ;
    opacity: 1;
  }
  100% {
    transform: scale(1) ;
  }
`;


export default function Home() {

    return (
        <>
            <EggsLayout/>
        </>
    )
}

export const getServerSideProps: GetServerSideProps<{}> = async (context: any) => {
  try{
      const {language} = context.query
      return { 
          props: { 
              ...(
                  await serverSideTranslations(
                      language ?? "fr",
                      ['common'],
                      nextI18NextConfig as UserConfig
                  )
              ),       
          } 
      }
  }catch(e){

  }

  return {
      notFound: true,
    }
}